<template>
    <div
            class="step-link"
            :class="`status-${status}`"
    >
        <div class="status-indicator">
            <template v-if="status === STATUS_DONE">
                <i
                        class="far fa-check status-icon"
                />
            </template>
            <template
                    v-else
            >
                <i
                        v-if="faIcon"
                        class="icon"
                        :class="faIcon"
                />
                <div
                        v-else
                        class="dot"
                />
            </template>
            <div class="line" />
        </div>
        <div class="action">
            <slot />
        </div>
    </div>
</template>

<script>
    const STATUS_DEFAULT = 10;
    const STATUS_CURRENT = 20;
    const STATUS_DONE = 30;
    export {STATUS_CURRENT, STATUS_DEFAULT, STATUS_DONE};
    export default {
        name: 'StepLink1',
        props: {
            faIcon: {
                type: String
            },
            status: {
                type: Number,
                default: () => STATUS_DEFAULT
            }
        },
        data() {
            return {
                STATUS_DEFAULT,
                STATUS_CURRENT,
                STATUS_DONE
            };
        }
    };
</script>

<style>

</style>
